import React from 'react';
import Style from '../assets/style.scss';
import LicenceInfo, { ILicenceInfo, defaultLicenceInfo } from './widgets/LicenceInfo';
import LicenceUsers, { IUserAction } from './widgets/licenceUsers';
import PanelHeader from './widgets/panelHeader';
import ILicenceManagementProps from '../entities/ILicenceManagementProps';
import SettingsModal from './widgets/settingsModal';
import { ServiceList } from '@bimser/common';

const LicenceManagement = (props: ILicenceManagementProps) => {
	const [showSettings, setShowSettings] = React.useState<boolean>(false);
	const [userActions, setUserActions] = React.useState<Array<IUserAction>>([]);
	const [licenceInfo, setLicenceInfo] = React.useState<ILicenceInfo>(defaultLicenceInfo);
	const handleRefresh = () => {
		getUserActions();
		getLicenceInfo();
	};

	const openSettinsgModal = () => {
		setShowSettings(true);
	};

	const closeModal = () => {
		setShowSettings(false);
	};

	const getLicenceInfo = () => {
		ServiceList.web.License.GetLicense.callPromise()
			.then(response => {
				if (response) setLicenceInfo(response);
				else setLicenceInfo(defaultLicenceInfo);
			})
			.catch(() => {
				setLicenceInfo(defaultLicenceInfo);
				throw new Error('Data Loading Error');
			});
	};

	const getUserActions = () => {
		ServiceList.web.License.GetLicenseUsers.callPromise()
			.then(response => {
				if (response.data)
					setUserActions(
						response.data.map((item, index) => {
							return {
								id: index++,
								...item
							};
						})
					);
				else setUserActions([]);
			})
			.catch(() => {
				setUserActions([]);
				throw new Error('Data Loading Error');
			});
	};

	React.useEffect(() => {
		getLicenceInfo();
		getUserActions();
	}, []);

	return (
		<div className={Style.licenceManagementContainer}>
			<SettingsModal
				closeModal={closeModal}
				visible={showSettings}
			/>
			<PanelHeader
				panelGuid={props.panelGuid}
				closeFlexPanel={props.closeFlexPanel}
				handleRefresh={handleRefresh}
				openSettinsgModal={openSettinsgModal}
			/>
			<LicenceInfo {...licenceInfo} />
			<LicenceUsers actions={userActions} />
		</div>
	);
};

export default LicenceManagement;
